import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useAssignUser = () => {
  const mutation = useMutation((formData) => {
    return axiosClient.post(`/Project/AssignUserToProject`, formData);
  });
  return mutation;
};
export default useAssignUser;
